import Vue from 'vue'
import Vuex from 'vuex'

import appModule from './modules/app-module'
import authModule from './modules/auth-module'
import userModule from './modules/user-module'
import subscriptionModule from './modules/subscription-module'
import contentModule from './modules/content-module'
import paymentMethodModule from './modules/payment-method-module'
import agencyModule from './modules/agency-module'
import businessModule from './modules/business-module'
import whitelabelModule from './modules/whitelabel-module'
import landingPageModule from "./modules/landingpage-module";
import podcastModule from "./modules/podcast-module";

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: false,
  modules: {
    app: appModule,
    auth: authModule,
    user: userModule,
    paymentMethod: paymentMethodModule,
    subscription: subscriptionModule,
    content: contentModule,
    agency: agencyModule,
    business: businessModule,
    whitelabel: whitelabelModule,
    landingPage: landingPageModule,
    podcast: podcastModule
  },
})

export default store
